import {
    useAccountDictionary,
    useAgentDictionary,
    useAlertNameDictionary,
    useAllowedCountryDictionary,
    useAuditTableDictionary,
    useBookmakerDictionary,
    useBotDictionary,
    useBrowserDictionary,
    useCountryDictionary,
    useCustomLeagueDictionary,
    useNotPlayerDictionary,
    usePageDictionary,
    usePositionPlatformRuleDictionary,
    usePositionUserRuleDictionary,
    useProxyDictionary,
    useTimeZoneDictionary,
    useTransferMethodDictionary,
} from '@/stores';

export function setRemoteDictionaries(dictionaries: Record<string, any[]>) {
    for (const dictionaryName in dictionaries) {
        if (dictionaryName === 'Agent') {
            const store = useAgentDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'NotPlayer') {
            const store = useNotPlayerDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'Account') {
            const store = useAccountDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'AllowedCountry') {
            const store = useAllowedCountryDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'Country') {
            const store = useCountryDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'CustomLeague') {
            const store = useCustomLeagueDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        //should be SiteAll only
        if (/*dictionaryName === 'Site' || */ dictionaryName === 'SiteAll') {
            const store = useBookmakerDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'Bot') {
            const store = useBotDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'Proxy') {
            const store = useProxyDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'Browser') {
            const store = useBrowserDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'TimeZone') {
            const store = useTimeZoneDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'AlertName') {
            const store = useAlertNameDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'Page') {
            const store = usePageDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'TransferMethod') {
            const store = useTransferMethodDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'AuditTable') {
            const store = useAuditTableDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'PositionPlatformRule') {
            const store = usePositionPlatformRuleDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'PositionUserRule') {
            const store = usePositionUserRuleDictionary();
            store.setData(dictionaries[dictionaryName]);
        }
    }
}
